import http from '../utils/http';
export default{
    GetMedicalListWithPrintTJ(QueryText){
        let postData = { apiID: '30CD99AA-A162-43C3-99E5-48521E7FC3A5'//GetMedicalListWithPrintTJ
            , data: { QueryText: QueryText } };
        return http.post(sys.apiUrl, postData)
    },
}


// WEBPACK FOOTER //
// ./src/api/print.api.js